import { render, staticRenderFns } from "./adjuDetail.vue?vue&type=template&id=80ed40ba&scoped=true"
import script from "./adjuDetail.vue?vue&type=script&lang=js"
export * from "./adjuDetail.vue?vue&type=script&lang=js"
import style0 from "./adjuDetail.vue?vue&type=style&index=0&id=80ed40ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ed40ba",
  null
  
)

export default component.exports